import { COLORS, borderRadiusSm, gapXs, paddingSm } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

interface StyledProps {
  areBothPriceTypesShown: boolean;
  hasDiscount: boolean;
  onlyGrossValue: boolean;
  onlyNetValue: boolean;
  externalMode: boolean;
}

export const ContainerAbsolute = styled.div`
  max-height: 80vh;
  overflow: auto;
  position: absolute;
  border-radius: ${borderRadiusSm};
  background-color: ${COLORS.WHITE};
  border: 1rem solid ${COLORS.BORDER};
  min-width: 200rem;
  top: 50rem;
  padding-top: ${paddingSm};
  display: flex;
  flex-direction: column;

  ${(props: StyledProps) =>
    !props.externalMode &&
    respondTo.midTablet`
    min-width: auto;
    position: fixed;
    top: auto;
    bottom: 100rem;
    max-height: calc(100vh - 150rem);
  `}

  ${respondTo.smallPhone`
    max-height: calc(100vh - 200rem);
    padding: 20rem 5rem;
  `}
`;

export const PriceLabel = styled.div`
  min-width: 100rem;
  color: ${COLORS.BLACK};
  white-space: nowrap;

  ${respondTo.midTablet`
    min-width: 90rem;
    white-space: normal;
  `}

  ${respondTo.smallPhone`
    font-size: 15rem;
    min-width: 80rem;
  `}
`;

export const PriceLabelValue = styled.div`
  /* min-width: 50rem; */
  color: ${COLORS.BLACK};
  white-space: nowrap;

  ${respondTo.smallPhone`
    font-size: 15rem;
    min-width: 40rem;
  `}
`;

export const TooltipPriceLabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${gapXs};

  ${respondTo.smallPhone`
    gap: 5rem;
  `}
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props: StyledProps) =>
    props.areBothPriceTypesShown && props.hasDiscount
      ? '1fr 1fr 1fr 1fr'
      : props.onlyGrossValue || props.onlyNetValue
      ? '1fr 1fr'
      : '1fr 1fr 1fr'};
  gap: 16rem 20rem;
  padding: 0 20rem 20rem;

  ${respondTo.midTablet`
    gap: 10rem 25rem;
  `}
`;

export const Margin20 = styled.div`
  width: 20rem;
  height: 24rem;
`;

export const QuantityLabel = styled.span`
  display: block;
  font-weight: 600;
  font-size: 16rem;
  color: ${COLORS.GREEN};

  ${respondTo.smallPhone`
    font-size: 15rem;
  `}
`;

export const DiscountLabel = styled.span`
  display: block;
  font-weight: 300;
  font-size: 16rem;
  color: ${COLORS.BLACK};
  min-width: 100rem;
  display: ${(props: StyledProps) => (props.hasDiscount ? 'block' : 'none')};

  ${respondTo.smallPhone`
    font-size: 15rem;
    min-width: 60rem;
  `}
`;

export const DiscountWrapper = styled.div`
  display: ${(props: StyledProps) => (props.hasDiscount ? 'block' : 'none')};
`;

export const NetPriceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10rem;
`;

export const DiscountValue = styled.div`
  min-width: 50rem;
  color: ${COLORS.BLACK};
  white-space: nowrap;
`;

export const CustomNetPriceWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 100%;
  padding: 5rem;
  background-color: ${COLORS.GREEN};
  cursor: pointer;
`;

export const CustomNetPriceLabel = styled.span`
  display: block;
  color: ${COLORS.STRICT_WHITE};
  font-weight: 600;
  text-transform: uppercase;
`;
